export const clientsRouteEntries = {
  clientsList: () => import('./presentation/client/ClientsListPage'),
  clientForm: () => import('./presentation/client/ClientFormPage'),
  clientDetail: () => import('./presentation/client/ClientDetailPage'),
  opportunityDetail: () => import('./presentation/opportunities/OpportunityDetailPage'),
  opportunityTemplatesAdmin: () =>
    import('./presentation/opportunities/OpportunityStepTemplatesAdminPage'),
  clientSalas: () => import('./presentation/infraNav/ClientSalasPage'),
  clientRacks: () => import('./presentation/infraNav/ClientRacksPage'),
} as const;